export default "__VITE_ASSET__DD1iWZXS__"